/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Charge/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Amount from './Amount/index'
import React from 'react'
import RemoveAction from './RemoveAction/index'
import ToothNumber from './ToothNumber/index'
import ToothSurface from './ToothSurface/index'
import Type from './Type/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Charge({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreateClaim/Charges/Charge"
  
}) {
let chargeItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'charge_item',
path: 'isLast',
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Charge.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-2nG5Pd': !chargeItemIsLastValueData ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : "0px",'--mb-2-2nG5Pd': !chargeItemIsLastValueData ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : "0px",'--bbs-3-2nG5Pd': !chargeItemIsLastValueData ? "dashed" : "transparent",'--bbw-4-2nG5Pd': !chargeItemIsLastValueData ? "1px" : "0px",'--bbc-5-2nG5Pd': !chargeItemIsLastValueData ? dtColorsNeutral200 : dtColorsNeutral200}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Charge.Horizontal"
  data-view-path={viewPath}
 style={{'--g-6-2nG5Pd': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Type
  viewPath={`${viewPath}/Type`}
/>
<Amount
  viewPath={`${viewPath}/Amount`}
/>
<RemoveAction
  viewPath={`${viewPath}/RemoveAction`}
/>
</div>
<div
  data-testid="Charge.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-6-2nG5Pd': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-7-2nG5Pd': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<ToothNumber
  viewPath={`${viewPath}/ToothNumber`}
/>
<ToothSurface
  viewPath={`${viewPath}/ToothSurface`}
/>
</div>
</div>
{children}
</React.Fragment>)
}